import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/native';
import { useField, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { View, Text, TextInput, Modal, Pressable } from 'react-native';

import {
  elRed,
  elGray
} from '../../styles/colors';

export const SalespersonContainer = styled(View)`
  padding: 40px;
`;

export const ModalContainer = styled(Pressable)`

`;

export const SalespersonShowContainer = styled(View)`
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ButtonContainer = styled(View)`

`;
